import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "./src/constants/endpoints";

const isLocalhost = typeof globalThis !== "undefined" && 
  (globalThis.location.hostname === "localhost" || globalThis.location.hostname === "127.0.0.1");

Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,
  enableLogs: false,
  enabled: !isLocalhost,
});
